import { render, staticRenderFns } from "./preview-customerorder.vue?vue&type=template&id=63c8b882&scoped=true&"
import script from "./preview-customerorder.vue?vue&type=script&lang=js&"
export * from "./preview-customerorder.vue?vue&type=script&lang=js&"
import style0 from "./preview-customerorder.vue?vue&type=style&index=0&id=63c8b882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c8b882",
  null
  
)

export default component.exports